"use client";
import { AttachedMediaType } from "@/lib/types";
import {
  createContext,
  FC,
  ReactNode,
  useCallback,
  useMemo,
  useState,
} from "react";

interface StateContextProps {
  handleSearchFilter: (str: string) => void;
  handleSelectFilter: (str: string) => void;
  hideProjectModal: VoidFunction;
  searchFilter: string;
  selectedImage: AttachedMediaType;
  selectedFilter: string;
  showModal: boolean;
  showProjectModal: (images: AttachedMediaType) => void;
}

const StateContext = createContext<StateContextProps | null>(null);

const StateContextProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [searchFilter, setSearchFilter] = useState<string>("");
  const [selectedFilter, setSelectedFilter] = useState<string>("");
  const [selectedImage, setSelectionImage] = useState<AttachedMediaType>({});
  const [showModal, setShowModal] = useState<boolean>(false);

  const handleSearchFilter = useCallback(
    (val: string) => setSearchFilter(val),
    []
  );

  const handleSelectFilter = useCallback(
    (val: string) => setSelectedFilter(val),
    []
  );

  const showProjectModal = useCallback((image: AttachedMediaType) => {
    setShowModal(true);
    setSelectionImage(image);
  }, []);

  const hideProjectModal = useCallback(() => {
    setShowModal(false);
    setSelectionImage({});
  }, []);

  const contextValue = useMemo<StateContextProps>(
    () => ({
      searchFilter,
      handleSearchFilter,
      selectedFilter,
      handleSelectFilter,

      showModal,
      selectedImage,
      showProjectModal,
      hideProjectModal,
    }),
    [
      searchFilter,
      handleSearchFilter,
      selectedFilter,
      handleSelectFilter,
      showModal,
      selectedImage,
      showProjectModal,
      hideProjectModal,
    ]
  );

  return (
    <StateContext.Provider value={contextValue}>
      {children}
    </StateContext.Provider>
  );
};

export { StateContextProvider, StateContext };
